import { useEffect, useState } from 'react';
import api from '../../services/api';

// Active return reasons (GET /api/return-reasons, db/730) labelled with their single name, shown as-is in every language.
// `enabled` false -> no request. A failed read leaves the list empty (the API still enforces the rule).
export default function useReturnReasons(enabled) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!enabled) return undefined;
    let live = true;
    Promise.resolve().then(() => api.request('/return-reasons')).then(d => { if (live && Array.isArray(d)) setRows(d); }).catch(() => {});
    return () => { live = false; };
  }, [enabled]);
  return rows.map(r => ({ code: r.code, label: r.name }));
}
